import { useModal } from "mui-modal-provider";
import { ShowFnOutput } from "mui-modal-provider/dist/types";
import { Button } from "shared/components/atoms/Button";
import {
  BaseModal,
  BaseModalProps,
} from "shared/components/organisms/modal/BaseModal";

export interface BlockUserModalProps extends BaseModalProps {
  onClick: () => void;
}

export const BlockUserModal = ({
  onClick,
  ...baseModalProps
}: BlockUserModalProps) => {
  return (
    <BaseModal
      title={`この鑑定メニューは\n現在ご利用できません`}
      subTitle="時間をおいてから再度お試しいただくか、他の占い師の先生の鑑定メニューをお試しください🙇‍♂️"
      {...baseModalProps}
    >
      <Button onClick={onClick} tw="w-full bg-gradient-theme-to-l">
        OK
      </Button>
    </BaseModal>
  );
};

export const useBlockUserModal = () => {
  const { showModal, ...modal } = useModal();

  const showBlockUserModal = () => {
    const modal: ShowFnOutput<BlockUserModalProps> = showModal(BlockUserModal, {
      onClick: () => modal.destroy(),
    });
  };

  return {
    showModal: showBlockUserModal,
    ...modal,
  };
};
